import { DossierOpenSearch, DossierFormaliteApiObject } from '@europrocurement/l2d-domain';
import { createContext, useContext } from 'react';
import { UpdateDossierPayload } from '../types/UpdateDossierPayload';

interface SelectedDossierContextType {
    dossier: DossierOpenSearch;
    setDossier: React.Dispatch<React.SetStateAction<DossierOpenSearch>>;
    siblings: Array<DossierOpenSearch>;
    setSiblings: React.Dispatch<React.SetStateAction<DossierOpenSearch[]>>;
    updateDossier: (payload: UpdateDossierPayload) => void;
    refreshDossier: () => void;
    dossierWithNotes: DossierFormaliteApiObject;
    setDossierWithNotes: React.Dispatch<React.SetStateAction<DossierFormaliteApiObject>>;
    refreshDossierWithNotes: () => Promise<void>;
    notesLoading: boolean;
    notesError: string | null;
}

const defaultContext: SelectedDossierContextType = {
    dossier: { formalites: [], validationProcesses: [] },
    setDossier: () => {},
    siblings: [],
    setSiblings: () => {},
    updateDossier: () => {},
    refreshDossier: () => {},
    dossierWithNotes: {},
    setDossierWithNotes: () => {},
    refreshDossierWithNotes: async () => {},
    notesLoading: false,
    notesError: null,
};

const SelectedDossierContext = createContext<SelectedDossierContextType>(defaultContext);

export default SelectedDossierContext;

export const useSelectedDossierContext = () => {
    const context = useContext(SelectedDossierContext);
    if (!context) {
        throw new Error('useSelectedDossierContext must be used within a SelectedDossierProvider');
    }
    return context;
};
